import { oneOf } from 'prop-types';
export default oneOf(['entity', 'country']);
